<template>
    <a-modal :title="title" :visible.sync="show" :width="1000" ok-text="使用这个位置" @ok="execEnter" @cancel="() => $emit('update:show', false)">
        <a-form-model :model="field">
            <a-row :gutter="10">
                <a-col :span="16">
                    <a-form-model-item>
                        <a-input v-model="field.addr" placeholder="请在地图上选点标记位置" :style="{ width: '100%' }"></a-input>
                    </a-form-model-item>
                </a-col>
                <a-col :span="3">
                    <a-form-model-item>
                        <a-input v-model="field.code" placeholder="地区代码" :style="{ width: '100%' }" disabled></a-input>
                    </a-form-model-item>
                </a-col>
                <a-col :span="5">
                    <a-form-model-item>
                        <a-input v-model="field.locs" placeholder="经纬度" :style="{ width: '100%' }" disabled></a-input>
                    </a-form-model-item>
                </a-col>
            </a-row>
        </a-form-model>
        <div id="map" class="amap"></div>
    </a-modal>
</template>
<script>
export default {
    name: 'MapSelector',
    props: {
        show: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        locs: {
            type: Object,
            required: false,
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {
            map: undefined,
            geocoder: undefined,
            marker: undefined,
            field: {
                code: '',
                locs: '',
                addr: ''
            }
        }
    },
    beforeDestroy() {
        this.map && this.map.destroy()
        this.map = undefined
    },
    mounted() {
        this.init()
    },
    methods: {
        init() {
            // eslint-disable-next-line
            AMapLoader.load({
                key: 'e51413dde7532ed95e2b2a923dbb9c95',
                version: '2.0',
                plugins: ['AMap.Scale', 'AMap.Geocoder']
            })
                .then(AMap => {
                    this.geocoder = new AMap.Geocoder({
                        radius: 1000
                    })
                    this.map = new AMap.Map('map', {
                        resizeEnable: true,
                        zoom: 16
                    })
                    this.map.addControl(new AMap.Scale())
                    this.map.on('click', e => {
                        this.addMarker(e.lnglat.getLng() + ',' + e.lnglat.getLat())
                    })
                    if (this.locs.locs) {
                        this.addMarker(this.locs.locs)
                        Object.keys(this.field).forEach(key => (this.field[key] = this.locs[key] || this.field[key] || ''))
                    }
                })
                .catch(() => {
                    this.$message.error('地图加载错误，请刷新重试', () => {
                        this.$emit('update:show', false)
                    })
                })
        },
        execEnter() {
            if (this.marker === undefined || !this.marker.getPosition()) {
                this.$message.error('请点击地图选择地点')
                return
            }
            this.$emit('change', this.field)
            this.$emit('update:show', false)
        },
        addMarker(loc) {
            if (this.marker === undefined) {
                this.map.setZoom(16)
                // eslint-disable-next-line
                this.marker = new AMap.Marker({
                    icon: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png'
                })
            }
            this.map.clearMap()
            if (!loc) {
                return
            }
            this.marker.setPosition([parseFloat(loc.split(',')[0]), parseFloat(loc.split(',')[1])])
            this.map.panTo(this.marker.getPosition())
            this.map.add(this.marker)
            this.geocoder.getAddress(this.marker.getPosition(), (status, result) => {
                if (status === 'complete' && result.regeocode) {
                    this.field.locs = this.marker.getPosition().lng + ',' + this.marker.getPosition().lat
                    this.field.code = result.regeocode.addressComponent.adcode
                    this.field.addr = result.regeocode.formattedAddress
                } else {
                    this.$message.error('读取高德位置信息失败')
                }
            })
        }
    }
}
</script>

<style>
.amap {
    width: 100%;
    height: 500px;
}
</style>
